import React from 'react';

export default () => (
  <svg width="23" height="23" viewBox="0 0 23 23" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.4 3.888V0.5C4.9 1.05 0.5 5.791 0.5 11.5C0.5 17.209 4.9 21.95 10.4 22.5V19.112C7.1 18.584 3.8 15.372 3.8 11.5C3.8 7.628 7.1 4.416 10.4 3.888Z" fill="currentColor" />
    <path d="M22.4957 10.4H19.1627C18.6897 7.1 15.8957 4.361 12.5957 3.888V0.5C18.0957 1.017 21.9787 4.9 22.4957 10.4Z" fill="currentColor" />
    <path d="M12.5 22.5V19.0778C15.8333 18.6 18.6556 15.8333 19.1333 12.5H22.5C21.9778 18.0556 18.0556 21.9778 12.5 22.5Z" fill="currentColor" />
  </svg>
);
